import React from "react";
import { Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./PaginacionCompacta.scss";

/**
 * =============================================================================
 * PAGINACION PARA UNA LISTA EN MOVIL
 * =============================================================================
 * Dos flechas de 44 px y el contador escrito entre ellas.
 *
 * No se usa la paginacion normal de Ant Design en su modo compacto: su unica
 * funcion propia es teclear un numero de pagina, que abre el teclado encima de
 * la lista para pedir un dato que el terapeuta no puede conocer.
 *
 * Existe porque una lista que se convierte en fichas pierde la paginacion que
 * traia la tabla, y con ella todo lo que hubiera a partir del elemento diez.
 * =============================================================================
 */
export function PaginacionCompacta({ pagina, total, porPagina, onCambiar }) {
  const { t } = useTranslation("common");

  const paginas = Math.max(1, Math.ceil((total || 0) / (porPagina || 10)));
  if (paginas <= 1) return null;

  const actual = Math.min(Math.max(1, pagina || 1), paginas);

  return (
    <nav className="revi-paginacion" aria-label={t("pagination.label")}>
      <Button
        className="revi-paginacion__flecha"
        icon={<LeftOutlined />}
        disabled={actual <= 1}
        onClick={() => onCambiar?.(actual - 1)}
        aria-label={t("pagination.previous")}
      />

      <span className="revi-paginacion__contador">
        {t("pagination.showing", { n: actual, total: paginas })}
      </span>

      <Button
        className="revi-paginacion__flecha"
        icon={<RightOutlined />}
        disabled={actual >= paginas}
        onClick={() => onCambiar?.(actual + 1)}
        aria-label={t("pagination.next")}
      />
    </nav>
  );
}
